
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|3226|5052|8142)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
